//Mascara no CEP
jQuery(document).ready(function () {
    if (jQuery('body').hasClass("woocommerce-checkout")) {
        jQuery("#cfw-mobile-cart-header").click();

        jQuery(document).ready(function () {
            jQuery('#billing_postcode').mask('00000-000');
        });
    }
});

//Mascara Telefone
jQuery(function ($) {
    var $phone = $('#billing_phone');
    var PHONE_MASK = '(00) 00000-0000';

    if (!$phone.length) {
        return;
    }

    function nationalPhoneDigits(value) {
        var digits = String(value || '').replace(/\D/g, '');

        if (digits.length > 11 && digits.indexOf('55') === 0) {
            digits = digits.slice(2);
        }

        if (digits.length > 11 && digits.charAt(0) === '0') {
            digits = digits.slice(1);
        }

        return digits.slice(0, 11);
    }

    function needsNormalization(value) {
        return value.indexOf('+') !== -1 || value.replace(/\D/g, '').length > 11;
    }

    function normalizeAutofilledPhone() {
        var value = $phone.val() || '';

        if (!needsNormalization(value)) {
            return;
        }

        $phone.val($phone.masked(nationalPhoneDigits(value)));
    }

    if (needsNormalization($phone.val() || '')) {
        $phone.val(nationalPhoneDigits($phone.val()));
    }

    $phone.on('input.amcPhone change.amcPhone', normalizeAutofilledPhone);

    $phone.mask(PHONE_MASK);

    $phone.attr('maxlength', 25);
});


//Valida CPF
if (jQuery('#shipping_CPF')) {
    jQuery(document).ready(function () {

        jQuery("#shipping_CPF").mask("999.999.999-99");

        jQuery("#shipping_CPF").keyup(function () {
            if (validarCPF(jQuery("#shipping_CPF").val())) {
                jQuery('#place_order-next').removeClass('disabled');

                jQuery('#shipping_CPF').removeClass('cpf-erro');
                jQuery('#shipping_CPF_field').removeClass('cpf-erro');
                jQuery('#shipping_CPF_field').addClass('cpf-right');
            } else {
                jQuery('#place_order-next').addClass('disabled');
                jQuery('#shipping_CPF').addClass('cpf-erro');
                jQuery('#shipping_CPF_field').addClass('cpf-erro');
                jQuery('#shipping_CPF_field').removeClass('cpf-right');

            }
        });

        function validarCPF(cpf) {
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf == '') return false;
            // Elimina CPFs invalidos conhecidos
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999") {
                return false;}

            // Valida 1o digito
            var add = 0;
            for (var i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            var rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            // Valida 2o digito
            add = 0;
            for (i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        }
    });
}

//Removendo class nos inputs

jQuery( "label[for='billing_country']" ).removeClass( "screen-reader-text" );
jQuery( "label[for='billing_state']" ).removeClass( "screen-reader-text" );

jQuery(function($) {
    $('#billing_first_name, #billing_last_name, #shipping_CPF').on('change', function() {
        $('body').trigger('update_checkout');
    });
});
